const normalizePath = path => {
  if (!path) {
    return "";
  }

  return path.startsWith("/") ? path : `/${path}`;
};

const convertMenu = (menu, index, parentKey = "menu") => {
  const rawPath = normalizePath(menu.path || menu.route || "");
  const fallbackKey = `${parentKey}_${index}`;
  const key = rawPath.replace(/^\//, "") || fallbackKey;
  const title = menu.meta?.title || menu.title || menu.name || key;
  const children = Array.isArray(menu.children) ? menu.children.map((child, idx) => convertMenu(child, idx, key)).filter(Boolean) : undefined;
  return {
    key,
    title,
    path: rawPath || `/${fallbackKey}`,
    component: menu.component ? menu.component.replace(/^\/+/, "") : undefined,
    icon: menu.meta?.icon || menu.icon,
    hide: !!(menu.meta?.hideMenu || menu.meta?.hidden || menu.hidden || rawPath === "/system/user/info" || menu.component === "system/user/info"),
    children
  };
};

export const normalizeMenuData = (menus = []) => {
  return menus.map((menu, index) => convertMenu(menu, index)).filter(Boolean);
};
export const flattenMenus = (menus, parents = []) => {
  const result = [];
  menus.forEach(menu => {
    const breadcrumb = menu.hide ? parents : [...parents, menu.title];

    if (menu.component) {
      result.push({
        key: menu.key,
        title: menu.title,
        path: menu.path,
        component: menu.component,
        breadcrumb
      });
    }

    if (menu.children && menu.children.length) {
      result.push(...flattenMenus(menu.children, breadcrumb));
    }
  });
  return result;
};
export const buildParentMap = (menus, parent, map = new Map()) => {
  menus.forEach(menu => {
    if (parent) {
      map.set(menu.path, parent);
    }

    if (menu.children && menu.children.length) {
      buildParentMap(menu.children, menu.path, map);
    }
  });
  return map;
};
export const getFirstMenuPath = menus => {
  for (const menu of menus) {
    if (menu.component) {
      return menu.path;
    }

    if (menu.children && menu.children.length) {
      const childPath = getFirstMenuPath(menu.children);

      if (childPath) {
        return childPath;
      }
    }
  }

  return "";
};